/**
 * Helper functions for cell remark system
 */

/**
 * Build cell data object for remark creation
 * This identifies the cell uniquely without using x,y indices
 */
export const buildCellData = (params) => {
  const {
    cellType,
    date,
    module = 'prepack-inout', // default to prepack-inout
    productId = null,
    productGroupId = null,
    customerGroupId = null,
    customerSubGroupId = null,
    reserveLabel = null,
    finishedProductId = null,
    rawProductId = null,
    rawProductIds = null, // For groups
    arrivalIndex = null,
    // Additional display info
    productName = null,
    productGroupNo = null,
    // Arrival-specific (for clone/delete context menu actions)
    arrival_id_raw = null,
    product_ids = null,
  } = params;

  return {
    cell_type: cellType,
    date,
    module,
    product_id: productId,
    product_group_id: productGroupId,
    customer_group_id: customerGroupId,
    customer_sub_group_id: customerSubGroupId,
    reserve_label: reserveLabel,
    finished_product_id: finishedProductId,
    raw_product_id: rawProductId,
    raw_product_ids: rawProductIds, // For groups
    arrival_index: arrivalIndex,
    // Display info (not sent to backend, just for UI)
    product_name: productName,
    product_group_no: productGroupNo,
    // Arrival-specific
    arrival_id_raw,
    product_ids,
  };
};


/**
 * Handle context menu open event
 */
export const handleCellContextMenu = (e, cellData, setContextMenu, setSelectedCellData) => {
  console.log('cellData:', cellData);
  e.preventDefault();
  e.stopPropagation();

  setSelectedCellData(cellData);
  setContextMenu({
    visible: true,
    x: e.clientX,
    y: e.clientY,
  });
};

/**
 * Close context menu
 */
export const closeContextMenu = (setContextMenu) => {
  setContextMenu({ visible: false, x: 0, y: 0 });
};

/**
 * Check if a cell has remarks
 */
export const cellHasRemarks = (cellData, cellRemarks) => {
  if (!cellRemarks || !Array.isArray(cellRemarks) || cellRemarks.length === 0) return false;
  
  return cellRemarks.some(remark => {
    return (
      remark.cell_type === cellData.cell_type &&
      remark.date === cellData.date &&
      remark.module === cellData.module &&
      remark.product_id === cellData.product_id &&
      remark.product_group_id === cellData.product_group_id &&
      remark.customer_group_id === cellData.customer_group_id &&
      remark.customer_sub_group_id === cellData.customer_sub_group_id &&
      remark.reserve_label === cellData.reserve_label &&
      remark.finished_product_id === cellData.finished_product_id &&
      remark.raw_product_id === cellData.raw_product_id &&
      remark.arrival_index === cellData.arrival_index
    );
  });
};

/**
 * Generate data attributes for cell identification
 * Used for finding and highlighting cells after navigation
 */
export const getCellDataAttributes = (cellData) => {
  const attrs = {
    'data-cell-type': cellData.cell_type,
    'data-date': cellData.date,
  };
  
  // Only add attributes that have values
  if (cellData.product_id) attrs['data-product-id'] = cellData.product_id;
  if (cellData.product_group_id) attrs['data-product-group-id'] = cellData.product_group_id;
  if (cellData.customer_group_id) attrs['data-customer-group-id'] = cellData.customer_group_id;
  if (cellData.customer_sub_group_id) attrs['data-customer-sub-group-id'] = cellData.customer_sub_group_id;
  if (cellData.reserve_label) attrs['data-reserve-label'] = cellData.reserve_label;
  if (cellData.finished_product_id) attrs['data-finished-product-id'] = cellData.finished_product_id;
  if (cellData.raw_product_id) attrs['data-raw-product-id'] = cellData.raw_product_id;
  if (cellData.arrival_index !== null && cellData.arrival_index !== undefined) attrs['data-arrival-index'] = cellData.arrival_index;
  
  return attrs;
};
